/** The pack URL named by ?pack=… in a location search string, or null. */
export function packUrlFromSearch(search) {
  var v = new URLSearchParams(search).get('pack');
  return v ? v : null;
}

/** The test id named by ?test=… — the detail-view deep link. Part of the
 * viewer's URL contract alongside ?pack= (decision 2026-07-07). */
export function testIdFromSearch(search) {
  var v = new URLSearchParams(search).get('test');
  return v ? v : null;
}

/**
 * Normalize user-typed pack input. People paste the *viewer's* URL
 * (`…/?pack=<real-url>`) as often as the pack URL itself — if the input is a
 * URL carrying a `pack` query param, unwrap it and use that value instead.
 */
export function normalizePackInput(input) {
  try {
    var inner = new URL(input).searchParams.get('pack');
    if (inner) return inner;
  } catch (_unused) {
    // not an absolute URL — a relative path like /packs/x.evidence is fine as-is
  }
  return input;
}